{
  "roleId": "role-210000-mpers",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-200100x",
  "label": "[210000] Statement of financial position, by current/non-current method (MPERS)",
  "taxonomy": "FS-MPERS",
  "controls": [
    {
      "qname": "ssmt:DisclosureOnStatementOfProfitOrLossByFunctionAbstract",
      "label": "Statement of financial position",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:AssetsAbstract",
      "label": "Assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentAssetsAbstract",
      "label": "Non-current assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PropertyPlantAndEquipment",
      "label": "Property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:PropertyPlantAndEquipment"
        }
      }
    },
    {
      "qname": "ifrs-smes:InvestmentProperty",
      "label": "Investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:InvestmentProperty"
        }
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentBiologicalAssets",
      "label": "Biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:IntangibleAssetsAndGoodwill",
      "label": "Intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:IntangibleAssetsAndGoodwill"
        }
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInSubisidiaries",
      "label": "Investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ssmt-mpers:InvestmentInSubisidiaries"
        }
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInAssociates",
      "label": "Investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:InvestmentsInAssociates"
        }
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInJointVentures",
      "label": "Investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:InvestmentsInJointVentures"
        }
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
      "label": "Other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentReceivables",
      "label": "Trade and other non-current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:NoncurrentReceivables"
        }
      }
    },
    {
      "qname": "ifrs-smes:DeferredTaxAssets",
      "label": "Deferred tax assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentAssets",
      "label": "Other non-current assets",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentAssets",
      "label": "Total non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentAssetsAbstract",
      "label": "Current assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InventoriesTotal",
      "label": "Inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:InventoriesTotal"
        }
      }
    },
    {
      "qname": "ssmt-mpers:CurrentBiologicalAssets",
      "label": "Biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:CurrentInvestments",
      "label": "Other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentReceivables",
      "label": "Trade and other current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:TradeAndOtherCurrentReceivables"
        }
      }
    },
    {
      "qname": "ifrs-smes:CurrentTaxAssetsCurrent",
      "label": "Current tax assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:CurrentDerivativeFinancialAssets",
      "label": "Derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt:CashAndBankBalances",
      "label": "Cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ssmt:CashAndBankBalances"
        }
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ssmt:CashAndBankBalances"
          }
        ]
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentAssets",
      "label": "Other current assets",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:CurrentAssets",
      "label": "Total current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:Assets",
      "required": true,
      "label": "Total assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ifrs-smes:EquityAndLiabilities"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:EquityAndLiabilitiesAbstract",
      "label": "Equity and Liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:EquityAbstract",
      "label": "Equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IssuedCapital",
      "label": "Issued capital",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:IssuedCapital"
        }
      }
    },
    {
      "qname": "ifrs-smes:RetainedEarnings",
      "label": "Retained earnings",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:TreasuryShares",
      "label": "(-) Treasury shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:OtherReserves",
      "label": "Reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:OtherReserves"
        }
      }
    },
    {
      "qname": "ifrs-smes:EquityAttributableToOwnersOfParent",
      "required": true,
      "label": "Total equity attributable to owners",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherComponentsOfEquity",
      "label": "Equity - other components",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ssmt-mpers:OtherComponentsOfEquity"
        }
      }
    },
    {
      "qname": "ifrs-smes:NoncontrollingInterests",
      "label": "Non-controlling interests",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:Equity",
      "required": true,
      "label": "Total equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:LiabilitiesAbstract",
      "label": "Liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentLiabilitiesAbstract",
      "label": "Non-current liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentBorrowings",
      "label": "Loans and borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ssmt-mpers:NoncurrentBorrowings"
        }
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentProvisionsForEmployeeBenefits",
      "label": "Employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:NoncurrentProvisionsForEmployeeBenefits"
        }
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentProvisions",
      "label": "Provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:NoncurrentProvisions"
        }
      }
    },
    {
      "qname": "ifrs-smes:DeferredTaxLiabilities",
      "label": "Deferred tax liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentPayables",
      "label": "Trade and other non-current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:NoncurrentPayables"
        }
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentLiabilities",
      "label": "Other non-current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentLiabilities",
      "label": "Total non-current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentLiabilitiesAbstract",
      "label": "Current liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermBorrowings",
      "label": "Loans and borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:ShorttermBorrowings"
        }
      }
    },
    {
      "qname": "ifrs-smes:CurrentProvisionsForEmployeeBenefits",
      "label": "Employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:CurrentProvisionsForEmployeeBenefits"
        }
      }
    },
    {
      "qname": "ifrs-smes:CurrentProvisions",
      "label": "Provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:CurrentProvisions"
        }
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentPayables",
      "label": "Trade and other current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-smes:TradeAndOtherCurrentPayables"
        }
      }
    },
    {
      "qname": "ifrs-smes:CurrentTaxLiabilitiesCurrent",
      "label": "Current tax liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:CurrentDerivativeFinancialLiabilities",
      "label": "Derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentLiabilities",
      "label": "Other current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:CurrentLiabilities",
      "required": true,
      "label": "Total current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:Liabilities",
      "required": true,
      "label": "Total liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:EquityAndLiabilities",
      "required": true,
      "label": "Total equity and liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ifrs-smes:Assets"
          }
        ]
      }
    }
  ]
}
